(() => {
  document.addEventListener('toggle', (event) => {
    const current = event.target;
    if (!current.matches('.cy-nav-group') || !current.open) return;
    current.closest('nav').querySelectorAll('.cy-nav-group[open]').forEach(item => { if (item !== current) item.open = false; });
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.cy-nav-group[open], .cy-mobile-nav[open]').forEach(item => {
      if (!item.contains(event.target) || event.target.closest('a')) item.open = false;
    });
    const button = event.target.closest('[data-cy-video-toggle]');
    if (!button) return;
    const video = button.closest('.cy-film').querySelector('video');
    if (video.paused) video.play().catch(() => { video.controls = true; }); else video.pause();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.activeElement.closest('.cy-nav-group[open], .cy-mobile-nav[open]');
    document.querySelectorAll('.cy-nav-group[open], .cy-mobile-nav[open]').forEach(item => { item.open = false; });
    if (menu) menu.querySelector('summary').focus();
  });
  ['play', 'pause', 'ended'].forEach(type => document.addEventListener(type, event => {
    if (!event.target.matches('.cy-film video')) return;
    const video = event.target, button = video.closest('.cy-film').querySelector('[data-cy-video-toggle]');
    if (!button) return;
    button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
    button.setAttribute('aria-pressed', String(!video.paused));
    button.querySelector('[data-cy-video-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
    if (!video.paused) document.querySelectorAll('.cy-film video').forEach(other => { if (other !== video) other.pause(); });
  }, true));
  document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('.cy-film video').forEach(video => video.pause()); });
})();
